/* eslint no-console: 0 */
/* eslint no-empty-function: 0 */
/* eslint no-continue: 0 */
/* eslint no-shadow: 0 */
/* eslint no-unused-vars: 0 */
/* eslint class-methods-use-this: 0 */
/* eslint no-restricted-syntax: 0 */
/* eslint no-constant-condition: 0 */

/**
 * @ngdoc service
 *
 * @description
 * Object comparer service to be reused across the application.
 */

const VALUE_CREATED = 'created';
const VALUE_UPDATED = 'updated';
const VALUE_DELETED = 'deleted';
const VALUE_UNCHANGED = 'unchanged';

const ObjectComparer = {

    getFlattenDiff(oldValue, newValue) {

        const diff = this._map(oldValue, newValue);
        return this._flatten(diff);

    },

    _map(oldValue, newValue) {

        if (angular.isFunction(oldValue) || angular.isFunction(newValue)) {

            throw new Error('Invalid argument. Function given, object expected.');

        }

        if (this._isValue(oldValue) || this._isValue(newValue)) {

            const type = this._compareValues(oldValue, newValue);

            if (type === VALUE_UPDATED) {

                if (newValue === true || newValue === false) {

                    return String(newValue);

                }

                if (angular.isNumber(newValue)) {

                    return String(newValue);

                }

                return newValue || oldValue;

            }

            return undefined;

        }

        const diff = {};

        for (const key in oldValue) {

            if (Object.prototype.hasOwnProperty.call(oldValue, key)) {

                if (angular.isFunction(oldValue[key])) {

                    continue;

                }

                let value2;
                if (typeof (newValue[key] !== 'undefined')) {

                    value2 = newValue[key];

                }

                const value = this._map(oldValue[key], value2);
                if (value) {

                    diff[key] = value;

                }

            }

        }

        for (const key in newValue) {

            if (Object.prototype.hasOwnProperty.call(newValue, key)) {

                if (angular.isFunction(newValue[key]) || (typeof (diff[key]) !== 'undefined')) {

                    continue;

                }

                const value = this._map(undefined, newValue[key]);
                if (value) {

                    diff[key] = this._map(undefined, newValue[key]);

                }

            }

        }

        return diff;

    },

    _flatten(data) {

        const result = {};

        function recurse(cur, prop) {

            if (Object(cur) !== cur) {

                result[prop] = cur;

            } else if (angular.isArray(cur)) {

                const l = 0;
                for (let i = 0, l = cur.length; i < l; i += 1) {

                    recurse(cur[i], `${prop}[${i}]`);

                }

                if (l === 0) {

                    result[prop] = [];

                }

            } else {

                let isEmpty = true;
                for (const p in cur) {

                    if (Object.prototype.hasOwnProperty.call(cur, p)) {

                        isEmpty = false;
                        recurse(cur[p], prop ? `${prop}.${p}` : p);

                    }

                }

            }

        }

        recurse(data, '');

        return result;

    },

    _compareValues(oldValue, newValue) {

        if (oldValue === newValue) {

            return VALUE_UNCHANGED;

        }

        if (typeof (oldValue) === 'undefined') {

            return VALUE_CREATED;

        }

        if (typeof (newValue) === 'undefined') {

            return VALUE_DELETED;

        }

        return VALUE_UPDATED;

    },

    _isValue(obj) {

        return !angular.isObject(obj) && !angular.isArray(obj);

    },

};


export default ObjectComparer;



// WEBPACK FOOTER //
// ./scripts/common/services/util/-RFC.ObjectComparer.js